<template>
  <div>
    <hr />
    <span>Copyright © 2010-2019 History Reconsiderered, LLC</span>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
div {
  width: 90%;
  text-align: center;
  display: block;
  padding: 1.5rem;
}
</style>
